"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.myFunction = void 0;
function myFunction() {
    return Promise.resolve(["a", "b", "c"]);
}
exports.myFunction = myFunction;
//# sourceMappingURL=myFunction.js.map